import { ApiProperty } from "@nestjs/swagger";

export class PlantRackPosRequest{
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    rackPositionCode:string;
}